// @flow
import { pathOr } from 'ramda';

/**
 * Extracts contactId from a recipient object.
 * Handles both residents (direct contactId) and applicants (nested in applicants array).
 */
export const getContactIdFromRecipient = (recipient: Object): ?string => {
  if (recipient.contactId) {
    return recipient.contactId;
  }
  const applicant = recipient.applicants?.find(
    (a) => a.name === recipient.name,
  );
  return pathOr(
    null,
    ['applicantCustomer', 'customer', 'contactId'],
    applicant,
  );
};

export const getPhoneOptedInClass = ({
  smsDoubleOptIn,
  isSmsCommunication,
  preferenceData,
  contactId,
  isValidatingPreferences,
  phonesValidated,
  phoneNumber,
  validPhones,
}: {
  smsDoubleOptIn: boolean,
  isSmsCommunication: boolean,
  preferenceData: ?Object,
  contactId: ?string,
  isValidatingPreferences: ?boolean,
  phonesValidated: boolean,
  phoneNumber: string,
  validPhones: Array<any>,
}): string => {
  // New preference-based flow (smsDoubleOptIn ON)
  if (smsDoubleOptIn && isSmsCommunication && preferenceData?.recipients) {
    const pref = preferenceData.recipients.find(
      (r) => r.contactId === contactId,
    );
    if (pref) {
      return pref.isOptedIn
        ? 'et-circle-check text-success'
        : 'et-circle-delete text-red';
    }
    if (isValidatingPreferences) {
      return '';
    }
  }

  // Legacy phone validation flow
  if (!phonesValidated) {
    return '';
  }

  return validPhones.includes(phoneNumber)
    ? 'et-circle-check text-success'
    : 'et-circle-delete text-red';
};

/**
 * Calculates the count of opted-in recipients based on preference data.
 * Pure function - flag/communication type checks should be done at the call site.
 */
export const getOptedInCount = (
  preferenceData: ?Object,
  selectedRecipients: Array<Object>,
): number => {
  if (!preferenceData?.recipients) {
    return 0;
  }

  return selectedRecipients.filter((recipient) => {
    const contactId = getContactIdFromRecipient(recipient);
    const pref = preferenceData.recipients.find(
      (r) => r.contactId === contactId,
    );
    return pref?.isOptedIn === true;
  }).length;
};
